<template>
  <div v-if="floor && round">
    <MapFloorView :floor="floor" :round="round" :showgroupnumbers="showgroupnumbers" />
    <FlawModal
      v-if="flawModalVisable"
      :edit-flaw="selectedFlaw"
      @cancel="handleCloseFlawModal"
      @save="handleSaveFlaw"
      :show-map-button="false"
    />

    <!-- Header -->
    <div class="panel-list-header" :class="{ mobile: isMobile }">
      <div class="panel-filler-icon" />
        <div class="panel-header-item pos" :class="{ mobile: isMobile }">
          {{ isMobile ? $t('floorround.pos_short') : $t('floorround.pos') }}
        </div>

        <div class="panel-header-item" v-if="!isMobile">{{ $t('floorround.type') }}</div>
        <div class="panel-header-item placement">{{ $t('floorround.floor') }}</div>
        <div class="panel-header-item flaw-item" v-if="!isMobile">{{ $t('floorround.flaw') }}</div>
        <div class="panel-header-item" v-if="!isMobile">{{ $t('floorround.action') }}</div>
        <div class="panel-filler-special" :class="{ mobile: isMobile }" />
    </div>

    <div
  v-for="(item, index) in allRoundHistoryItems"
  :key="'all-' + index"
  class="panel-list done"
  :class="{ 'row-done': item.flaws?.some((flaw) => flaw.done) }"
>
  <div class="panel-list-item special" @click="handleActionClick(item)">
    <div
      class="fireprotection-icon"
      :class="[
        getType(item.mapItem?.fireProtection?.inventoryType)?.icon || getType(item).icon,
        { mobile: isMobile },
      ]"
    ></div>
  </div>

  <div
    class="panel-list-item pos"
    :class="{ mobile: isMobile }"
    @click="handleActionClick(item)"
  >
     {{ formatPositionNumber(item.mapItem?.positionNumber) }}
</div>

  <div class="panel-list-item" v-if="!isMobile" @click="handleActionClick(item)">
    {{ tTypeKey(item.mapItem?.fireProtection?.inventoryType) || item.name }}
  </div>

  <div class="panel-list-item placement" @click="handleActionClick(item)">
    {{ item.floorName }}
  </div>

    <div
      class="panel-list-item flaw-item"
      v-if="!isMobile"
      @click="handleActionClick(item)"
    >
      <ul v-if="item.flaws?.length" class="flaws-list">
        <li
          v-for="(flaw, fIndex) in item.flaws"
          :key="fIndex"
          :class="{ 'flaw-done': flaw.done }"
        >
          {{ TranslateFlawType(flaw)}}
        </li>
      </ul>
      <span v-else></span>
    </div>

    <div class="panel-list-item" v-if="!isMobile">
      <span v-if="item.flaws?.some((flaw) => flaw.done)">
        {{ new Date(item.flaws.find((flaw) => flaw.done).done).toLocaleDateString() }}
      </span>
    </div>

    <div class="panel-filler-special" :class="{ mobile: isMobile }" />
  </div>
  </div>
</template>

<script>
import MapFloorView from "./MapFloorView.vue";
import iconMixin from "@/mixins/iconMixin.js";
import { mapGetters } from "vuex";
import FlawModal from "@/views/dashboard/FlawModal.vue";
export default {
  mixins: [iconMixin],
  name: "FloorRoundDisplay",
  components: {
    MapFloorView,
    FlawModal,
  },
  props: {
    floor: {
      type: Object,
      required: false,
    },
    round: {
      type: Object,
      required: false,
    },
    showgroupnumbers: {
    type: Boolean,
    default: true	
  }
  },
  data() {
    return {
      flawModalVisable: false, // Flytta hit
      selectedFlaw: null,
    };
  },
  methods: {
    formatPositionNumber(value) {
      if (value === null || value === undefined || value === "") return "-";

      const normalized = typeof value === "string" ? value.replace(",", ".").trim() : value;
      const num = Number(normalized);
      if (!Number.isFinite(num)) return String(value);

      const rounded = Math.round((num + Number.EPSILON) * 100) / 100;
      return rounded.toLocaleString("en-US", {
        useGrouping: false,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },
    getFlawDisplayName(flaw, fallbackName = null) {
      if (fallbackName) return fallbackName;

      const key = flaw?.flawType?.translationKey;
      if (key) return this.$t(key);

      return flaw?.name || "-";
    },

    LooseFlawFPType(flaw)
    {

      var translationKey = flaw?.flawType?.translationKey
      if(translationKey)
      {
      }
    },
    TranslateFlawType(flaw) {
        const _ = this.$i18n.locale;

        const ft = flaw && flaw.flawType ? flaw.flawType : null;

        if (
          ft &&
          ft.translationKey &&
          !ft.translationKey.includes('other')
        ) {
          return this.$t(ft.translationKey);
        }

        
        return this.tDescription(flaw?.name);
    },
    handleActionClick(item) {

     

      try {
        if (item && Array.isArray(item.flaws) && item.flaws.length > 0) {
          const flaw = item.flaws[0];

          if (item.mapItem?.fireProtection?.name) {
            flaw.mapItemName = item.mapItem.fireProtection.name;
          } else if (flaw?.flawType?.translationKey) {
            flaw.mapItemName = this.$t(flaw.flawType.translationKey)
          }
          else{
             flaw.mapItemName = '-'
          }
          LooseFlawFPType(flaw);
          this.selectedFlaw = flaw;
          this.flawModalVisable = true;
        }
      } catch (e) {
      }
    },


    handleCloseFlawModal() {
      this.flawModalVisable = false;
      this.selectedFlaw = null;
    },

    async handleSaveFlaw(flaw) {
      this.handleCloseFlawModal();
      this.isPending = true;

      try {
        await this.$services.flaw.updateFlaw(flaw);

        this.$refs?.dashboardActions?.fetchData();
      } catch (error) {
        console.error(error.message);
      }

      this.isPending = false;
    },
  },
  computed: {
    ...mapGetters("appStore", ["isMobile"]),
    currentFloorItems() {
      if (!this.floor || !this.round || !this.round.roundHistoryInfos) return [];
      const match = this.round.roundHistoryInfos.find(
        (info) => info.floorName === this.floor.name
      );
      return match ? match.roundHistoryItems || [] : [];
    },
    allRoundHistoryItems() {
      if (!this.round || !this.round.roundHistoryInfos) return [];

      const infos = this.round.roundHistoryInfos;
      const byId = new Map(); 

      for (const info of infos) {
        const floorName = info.floorName;

        for (const item of info.roundHistoryItems || []) {
          for (const flaw of item.flaws || []) {
            if (!flaw || !flaw.id) continue;
            if (byId.has(flaw.id)) continue;

            byId.set(flaw.id, {
              id: item.id,
              mapItem: item.mapItem || null,
              floorName,
              flaws: [flaw],
              isLoose: !item.mapItem,
              name: this.getFlawDisplayName(flaw, item.name),
            });
          }
        }

        for (const flaw of info.flaws || []) {
          if (!flaw || !flaw.id) continue;
          if (byId.has(flaw.id)) continue;

          byId.set(flaw.id, {
            id: `loose-${flaw.id}`,
            mapItem: null,
            floorName,
            flaws: [flaw],
            isLoose: true,
            name: this.getFlawDisplayName(flaw),
          });
        }
      }

      return Array.from(byId.values());
    },
  },
  watch: {
    floor: {
      handler(newFloor) {
        if (!newFloor) return;

        if (this.round && this.round.roundHistoryInfos) {
          const t = this.round.roundHistoryInfos.find(
            (info) => info.floorName === newFloor.name
          );
          if (t) {
            console.log("Matchande rondering för ny våning:", t.roundHistoryItems);
          }
        }
      },
      immediate: true,
    },
    round: {
      handler(newRound) {
        if (!newRound || !newRound.roundHistoryInfos) return;

        const t = newRound.roundHistoryInfos.find(
          (info) => info.floorName === this.floor?.name
        );
        if (t) {
          console.log("Rondering kopplad till nuvarande våning:", t.roundHistoryItems);
        }
      },
      immediate: true,
    },
     showgroupnumbers: {
      handler(newValue) {
       console.log('test tis',newValue)
      },
    
    },
    
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.title-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  &.flaw-title {
    margin-top: 1rem;
    .button {
      margin-top: -0.5rem;
      &.mobile {
        margin-right: 0.5rem;
        margin-left: auto;
        margin-top: -0.2rem;
        margin-bottom: 0.5rem;
      }
    }
  }
}

.flaw-done {
  background-color: #d4edda; /* ljusgrön */
  padding: 4px;
  border-radius: 4px;
}

.row-done {
  background-color: #d4edda !important;
}

.dash-select {
  margin-top: -0.5rem;
  &.mobile {
    margin-right: 0.5rem;
    margin-left: auto;
    margin-top: -0.5rem;
    margin-bottom: 0.5rem;
  }
}

.button {
  border-radius: 2px;
}

.panel-list-item.special {
  margin-right: 5px;
  max-width: 40px;
  position: relative;
}

.panel-list-item,
.panel-header-item {
  flex: 2;
  &.placement,
  &.flaw-item {
    flex: 3;
  }
}

.panel-list,
.panel-list-header {
  &.mobile {
    padding: 8px;
  }
}

.panel-list {
  &.not-done {
    background-color: #f0cbcb !important;
    &:nth-child(odd) {
      background-color: #e9b9b9 !important;
    }
  }

  &.ignored-not-done {
    background-color: rgba(255, 123, 0, 0.4);

    &:nth-child(odd) {
      background-color: rgba(255, 123, 0, 0.25);
    }
  }

  &.flaw-list {
    padding-top: 1rem;
  }
}

.fireprotection-icon {
  background-color: transparent;
  top: -7px;
  width: 30px;
  height: 30px;
  z-index: 2;
  position: absolute;
  background-size: contain;
  &.mobile {
    transform: translateY(30px);
  }
}

.panel-filler-special {
  margin-right: 120px;
  &.mobile {
    margin-right: 65px;
  }
}

.mobile-buttons {
  max-width: 65px;
  margin-right: 0;
  .button {
    width: 65px;
  }
}

.panel-list-item.pos,
.panel-header-item.pos {
  max-width: 80px;
  &.mobile {
    max-width: 40px;
  }
}

.button-container {
  margin-top: -16px;
  position: relative;
  margin-right: 120px;
  &.flaw {
    margin-top: -20px;
    margin-right: 83px;
    margin-left: 55px;
  }
  .field {
    position: absolute;
    top: 8px;
  }
  .instruction-icon {
    position: absolute;
    display: flex;
    left: -2.5rem;
    top: 0.5rem;
    height: 100%;
    padding: 0 0.5rem;
    &:hover {
      i {
        color: $info-active;
      }
      .instruction-tooltip {
        visibility: visible;
      }
    }
    > i {
      margin: auto;
    }
    .instruction-tooltip {
      visibility: hidden;
      background: #f7f7f7;
      border: 1px solid grey;
      border-radius: 4px;
      min-width: 360px;
      position: absolute;
      padding: 5px;
      right: 105%;
      top: -5px;
      white-space: pre-wrap;
      box-shadow: 5px 5px 5px $shadow-color;
    }
  }
}
</style>
